import { HttpClient, HttpHeaders } from "@angular/common/http";
import { GlobalsService } from "./globals";
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { MToolboxDashboard } from "../models/ToolboxDashboard.model";
import { MOrganizationUser } from "../models/organization-user.model";
import { Observable } from "rxjs";
import { MReportType } from "../models/report-type.model";

@Injectable({
  providedIn: "root",
})
export class SieniService {
  public toolbox: MToolboxDashboard = null;
  public orgUsers: MOrganizationUser[] = null;

  constructor(private http: HttpClient, private globals: GlobalsService) {}

  private header(): HttpHeaders {
    return new HttpHeaders({
      Authorization: "Bearer " + this.globals.user.token,
      Accept: "application/json",
      "Content-Type": "application/json",
    });
  }

  public setToolbox(newTbox: MToolboxDashboard) {
    this.toolbox = newTbox;
  }

  public getHelp(url: string) {
    return this.http.post(
      `${this.globals.apiUrl}/api/ayuda-sistema/search/${this.toolbox.id}`,
      { url: url }
    );
  }

  public getSettings(parent: string, key: string) {
    return this.http.get(`${this.globals.apiUrl}/api/settings/${parent}/${key}`);
  }

  public getReportTypes(idToolbox: string) {
    return this.http
      .get(`${this.globals.apiUrl}/api/reporte/toolbox/${idToolbox}`, {
        headers: this.header(),
      })
      .pipe(map((res: any) => res.data.map((item) => new MReportType(item))));
  }

  /**
   * @author Carlos Albornoz
   * @name getReport
   * @description Retorne el reporte generado
   */
  public getReport(url: string) {
    let header = new HttpHeaders({
      Authorization: "Bearer " + this.globals.user.token,
      Accept: "application/pdf",
      "Content-Type": "application/json",
    });
    return this.http.get(`${this.globals.apiUrl}/${url}`, {
      headers: header,
      responseType: "blob",
    });
  }

  public getOrganizationUsers(): Observable<MOrganizationUser[]> {
    return this.http
      .get(`${this.globals.apiUrl}/api/organizacion/usuario`, {
        headers: this.header(),
      })
      .pipe(
        map((res: any) =>
          res.data.map((element) => new MOrganizationUser(element))
        )
      );
  }

  public async getCurrentOrganizationUsers() {
    if (this.orgUsers) {
      return await this.orgUsers;
    } else {
      let users: MOrganizationUser[] = [];
      const value = await this.getOrganizationUsers()
        .toPromise()
        .then(async (res) => {
          users = res;
          this.orgUsers = res;
        });
      return await users;
    }
  }
}
